export const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:4000";
export const API_URL = process.env.REACT_APP_API_URL || BASE_URL;
export const BUILD_ID = process.env.REACT_APP_BUILD_ID || "local";
export const BUILD_HASH = process.env.REACT_APP_BUILD_HASH || "local";
